import { createSlice } from '@reduxjs/toolkit';
import { SessionStateType } from '@business/entities/session';
import type { RootState } from './store';

const initialState: SessionStateType = {
  isAdmin: false,
  userPermissions: [],
  notificationType: false,
  subscriberId: null
};

export const sessionStateSlice = createSlice({
  name: 'sessionStateSlice',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    resetSessionState: () => {
      return initialState;
    },
    setSubscriberId: (state, action) => {
      state.subscriberId = action.payload.subscriberId;
    },
    logoutUser: state => {
      state.isAdmin = false;
      state.token = null;
      state.refreshToken = null;
      state.userPermissions = [];
    }
  }
});

export const { setToken, resetSessionState, logoutUser, setSubscriberId } =
  sessionStateSlice.actions;
export const getToken = (state: RootState) => state.sessionStateSlice?.token;
export const getRefreshToken = (state: RootState) =>
  state.sessionStateSlice?.refreshToken;
export const getSubscriberId = (state: RootState) =>
  state.sessionStateSlice?.subscriberId;
